import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_ROLLBACK_DETAIL_REPORT } from '@custom/constant';

import axios from 'axios';

// Create the thunk for fetching rollback report details
export const fetchRollbackReport = createAsyncThunk(
  'rollbackReport/fetchRollbackReport',
  async (_id: string, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');

      const response = await axios.get(`${GET_ROLLBACK_DETAIL_REPORT}/${_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);
